import React from 'react';
import { get, post, put, del, patch } from '../../Http';
import { logsDetailsGet, logsDetailsFilterGet, logDetailsById } from '../Model/LogsModel';

import * as Store from '../../../store'
let version = Object.keys(Store.default.getState().LoginReducer.userCredentials).length > 0 ? Store.default.getState().LoginReducer.userCredentials.user_details.version : "";

export const logsDetails = async (data) => {
    version = Object.keys(Store.default.getState().LoginReducer.userCredentials).length > 0 ? Store.default.getState().LoginReducer.userCredentials.user_details.version : "";
    const response = await get(`${process.env.EXTENDED_URL}${version}/cm/jobs`, data);
    return logsDetailsGet(response);
};
export const logsDetailsFilter = async () => {
    version = Object.keys(Store.default.getState().LoginReducer.userCredentials).length > 0 ? Store.default.getState().LoginReducer.userCredentials.user_details.version : "";
    const response = await get(`${process.env.EXTENDED_URL}${version}/cm/jobs/filters`, null);
    return logsDetailsFilterGet(response);
};
export const getLogDetailsById = async (jobId) => {
    version = Object.keys(Store.default.getState().LoginReducer.userCredentials).length > 0 ? Store.default.getState().LoginReducer.userCredentials.user_details.version : "";
    const filters = encodeURIComponent(JSON.stringify([{
        "resource_name": "CMJob",
        "columns": ["*", "job_id"],
        "column_filters": [{ "job_id": jobId }]
    }]));
    const response = await get(`${process.env.EXTENDED_URL}${version}/generic?filters=${filters}`, null);
    return logDetailsById(response);
};
